export const getUploadedDocumentsStatuses = (documentdata = {}) => {
    const documentStatuses = {};
    if (!documentdata.otherDocuments) return documentStatuses;

    const { otherDocuments: documents = {} } = documentdata || {};
    Object.keys(documents).forEach((key) => {
        const doc = documents[key] || [];
        const counter = {
            total: 0
        };
        doc.forEach((elem) => {
            counter[elem.status] = (counter[elem.status] || 0) + 1;
            counter.total += 1;
        });
        documentStatuses[key] = counter;
    });
    return documentStatuses;
};
